exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fade-enter-active[data-v-1610e827],.fade-leave-active[data-v-1610e827]{transition:all .2s}.fade-enter[data-v-1610e827],.fade-leave-to[data-v-1610e827]{opacity:0;height:0;transition:all .5s}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1610e827","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/GobackTop.vue
// module id = 236
// module chunks = 0